import React, { PropsWithChildren } from "react";
import { useTranslation } from 'react-i18next';
import { IonContent, IonIcon, IonButton } from '@ionic/react';

import './ClaimableBalanceSuccess.css';

import { checkmarkOutline } from "ionicons/icons";

interface ClaimableSuccessProps extends PropsWithChildren {

    closeAction: Function;

}

const PaymentSuccess: React.FC<ClaimableSuccessProps> = (props) => {

    const { t, i18n } = useTranslation();

    return (
        <>

            <IonContent className='claimableBalanceSuccessContent'>

                <div className='ion-text-center' >
                    <IonIcon className="claimableBalanceSuccessIcon" icon={checkmarkOutline} size='large' >

                    </IonIcon>

                </div>

                <div className='ion-text-center'>
                    <h2 className="claimableBalanceSuccessLabel">
                        <b>{t('claimable.balance.success.page.CONTENT')}</b>
                    </h2>

                </div>

                <IonButton className="claimableBalanceSuccessCloseButton"

                    onClick={() => { props.closeAction() }}
                    fill='outline'
                    color="light"
                    expand='block'
                >
                    {t('claimable.balance.success.page.BTN')}
                </IonButton>

            </IonContent>

        </>
    )

}

export default PaymentSuccess